import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import { Context, StudyPlanTargets, Transitions } from "../../types"

export const confirmRecommendedRestoreModal: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({
    confirmRecommendedRestore: true
  }),
  exit: assign<Context>({
    confirmRecommendedRestore: false
  }),
  on: {
    RESTORE_PLAN: {
      target: "#StudyPlan.restore_to_recommended_plan_transition"
    },
    CANCEL: [
      {
        target: "#StudyPlan.teacher_view.idle",
        cond: ctx =>
          ctx.selfRefScope.scope === "TEACHER" &&
          ctx.currentTarget === StudyPlanTargets.TeacherView
      },
      {
        target: "#StudyPlan.review_plan.idle"
      }
    ]
  }
}
